import { Container, Graphics } from "pixi.js";
import { HORIZON, building, outdoor, tree } from "./common.js";

/** Donde termina la facultad: parqueo y vía interna. */
export function parqueo(): Container {
  const scene = outdoor({ ground: 0x8f9296, sky: 0x9ec9e8, hedge: 0x4c9c5b });

  scene.addChild(building(40, 100, 260, 142, 0xe8e0d2));

  // La vía interna cruza el fondo: es la calle que hay que cruzar para ir al parque.
  const road = new Graphics();
  road.rect(0, HORIZON, 960, 46).fill(0x5a5f63);
  for (let i = 0; i < 16; i++) {
    road.rect(i * 64 + 10, HORIZON + 20, 34, 6).fill({ color: 0xf2e8d8, alpha: 0.8 });
  }
  scene.addChild(road);

  // Plazas de estacionamiento, en perspectiva: separan el asfalto de la calle.
  const bays = new Graphics();
  for (let i = 0; i <= 8; i++) {
    const x = 120 * i;
    bays.moveTo(x, HORIZON + 60).lineTo(x + (x - 480) * 0.28, 540);
  }
  bays.stroke({ width: 3, color: 0xf2f2f2, alpha: 0.55 });
  scene.addChild(bays);

  scene.addChild(car(180, 350, 0xc0392b));
  scene.addChild(car(760, 340, 0x2f6fb2));
  scene.addChild(tree(900, HORIZON + 40, 0.8));

  return scene;
}

/**
 * Un auto visto desde atrás. Va en el escenario y no en el catálogo a propósito:
 * está fuera del área caminable, así que nadie va a chocar con él y no necesita ser
 * un objeto con colisión.
 */
function car(x: number, y: number, colour: number): Container {
  const c = new Container();

  const body = new Graphics();
  body.roundRect(x - 46, y - 34, 92, 54, 8).fill(colour).stroke({ width: 3, color: 0x2b2b2b });
  body.roundRect(x - 34, y - 54, 68, 26, 6).fill({ color: 0x2b3a47, alpha: 0.85 });
  body.rect(x - 40, y + 16, 18, 10).fill(0x2b2b2b);
  body.rect(x + 22, y + 16, 18, 10).fill(0x2b2b2b);
  c.addChild(body);

  return c;
}
